"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let TemplatePreview = class TemplatePreview extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    beginRenderTemplate(...args) {
        const item = this.item;
        this.isPDFLoading = true;
        $app.connections
            .request('render_template_test_html', {
            content: {
                ...this.item.getData(),
                data: JSON.parse(this.sampleData)
            },
            responseType: 'arraybuffer'
        })
            .then(response => {
            console.log(response);
            console.log(response.data);
            this.setData('file', new File([response.data], 'result.pdf', { type: response.headers['content-type'] }));
        })
            .finally(() => this.isPDFLoading = false);
    }
    item;
    onItem(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("item");
    }
    sampleData;
    onSample_data(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("sampleData");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    isPDFLoading;
    previewData;
    async $$load_previewData() {
        return this.beginRenderTemplate();
    }
    file;
    ux;
    b_7315092382398562_modalBindings;
    dataMembers = ['isPDFLoading', 'previewData', 'file', 'ux', 'b_7315092382398562_modalBindings'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                isPDFLoading: true,
                previewData: null,
                file: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "full-screen",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.pgettext("TemplatePreview", "Preview"),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_4840_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async evh_8564662037462133_clickPreventStop(event, scope) {
        return await this.actions.evh_8564662037462133_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async evh_1548630417156826_clickPreventStop(event, scope) {
        return await this.actions.evh_1548630417156826_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_4840 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_4840_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_4839 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_4840,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_4839],
        });
        const act_2248226175642056_closeComponent_4842 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_4841 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_4842,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_4841],
        });
        const act_8564662037462133_reloadComponentData_4844 = new core_1.actions.ReloadComponentDataAction({
            displayName: "reload",
            events: [],
        });
        const evh_8564662037462133_clickPreventStop_4843 = new core_1.actions.EventHandlerImpl({
            action: act_8564662037462133_reloadComponentData_4844,
            event: "click.prevent.stop",
            displayName: "reload",
        });
        const evh_8564662037462133_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8564662037462133_clickPreventStop_4843],
        });
        const act_1548630417156826_closeModal_4846 = new core_1.actions.CloseModalAction({
            events: [],
        });
        const evh_1548630417156826_clickPreventStop_4845 = new core_1.actions.EventHandlerImpl({
            action: act_1548630417156826_closeModal_4846,
            event: "click.prevent.stop",
            displayName: "closeModal",
        });
        const evh_1548630417156826_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1548630417156826_clickPreventStop_4845],
        });
        return {
            act_7315092382398562_closeModal_4840,
            evh_7315092382398562_close_4839,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_4842,
            evh_2248226175642056_close_4841,
            evh_2248226175642056_close,
            act_8564662037462133_reloadComponentData_4844,
            evh_8564662037462133_clickPreventStop_4843,
            evh_8564662037462133_clickPreventStop,
            act_1548630417156826_closeModal_4846,
            evh_1548630417156826_clickPreventStop_4845,
            evh_1548630417156826_clickPreventStop,
            reload: act_8564662037462133_reloadComponentData_4844,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], TemplatePreview.prototype, "item", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('item'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], TemplatePreview.prototype, "onItem", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: String,
    }),
    __metadata("design:type", String)
], TemplatePreview.prototype, "sampleData", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('sampleData'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], TemplatePreview.prototype, "onSample_data", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "full-screen",
    }),
    __metadata("design:type", String)
], TemplatePreview.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], TemplatePreview.prototype, "onSize", null);
TemplatePreview = __decorate([
    (0, vue_property_decorator_1.Component)()
], TemplatePreview);
exports.default = TemplatePreview;
vue_property_decorator_1.Vue.component("TemplatePreview", TemplatePreview);
